module.exports = __webpack_public_path__ + "media/images/carlota_nicolas-e41f52b9e815961414972c8e2bea7940.jpg";